import React from 'react';

import TableAntd from '../../../Components/TableAntd/TableAntd';

export default function InvoiceIssuerList() {
  const columns = (getColumnSearchProps) => {
    const columns = [
      {
        dataIndex: 'name',
        title: 'Nome',
        ...getColumnSearchProps('name', 'Nome'),
        sorter: (a, b) => a.name?.localeCompare(b.name),
        sortDirections: ['descend', 'ascend'],
      },
      {
        dataIndex: 'cnpj',
        title: 'CNPJ',
        ...getColumnSearchProps('cnpj', 'CNPJ'),
        sorter: (a, b) => a.cnpj?.localeCompare(b.cnpj),
        sortDirections: ['descend', 'ascend'],
      },
    ];
    return columns;
  };

  return (
    <TableAntd
      columnsTable={(getColumnSearchProps) => columns(getColumnSearchProps)}
      routePermissions="InvoiceIssuer"
      toggleStatusRoute="InvoiceIssuer"
      requestName="InvoiceIssuer"
      route="/EmissorNotaFiscal"
      cdPage="id"
      btnNew={true}
    />
  );
}
